import { useSelector } from 'react-redux';
import { CustomProvider, Drawer } from 'rsuite';
import { DrawerCompProps } from '../../Interfaces/Props';
import { IRootState } from '../../Storage/Redux/store';

const DrawerComp = (props: DrawerCompProps) => {
  const theme = useSelector((state: IRootState) => state.themeConfig.isDarkMode)
    ? 'dark'
    : 'light';

  return (
    <CustomProvider theme={theme}>
      <Drawer
        open={props.open}
        onClose={props.onClose}
        backdrop={props.backdrop !== undefined ? props.backdrop : 'static'}
        keyboard={props.closeOnEsc}
        size={props.size}
        placement={props.placement}
        style={props.style}
        className={props.className}
      >
        <Drawer.Header className={props.headerClassName}>
          <Drawer.Title>{props.title}</Drawer.Title>
          {props.action && <Drawer.Actions>{props.action}</Drawer.Actions>}
        </Drawer.Header>
        <Drawer.Body className={props.bodyClassName}>
          {props.children}
        </Drawer.Body>
      </Drawer>
    </CustomProvider>
  );
};

export default DrawerComp;
